<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g434ao/tc-custom/9781610587327.jpg?1731055740822" alt="This image is the cover for the book Zakka Handmades"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zakka Handmades
      </h1>
      <p class="bookDescription body article font2">
        <p>Learn how to sew simple, clever things that organize your home and help with daily tasks with <i>Zakka Handmades</i>! These incredibly useful projects include pouches and bags, small toys and baby items, and handy kitchen accessories. Some of the author’s sewn items also incorporate simple crochet. In Japanese, <i>zakka</i> means “household goods,” referring to items for domestic use—tableware, kitchenware, containers of various kinds, even simple clothing. What all the items have in common is a simple, fresh, handmade aesthetic; a subtle, clever wit; and absolute usefulness and practicality.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Morinaka
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Creative Publishing international, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?464ee9aa